import flow from 'lodash/flow';
import AnalyticsData from '@atlassian/jira-analytics-web-react/src/components/analytics-data.tsx';
import { AnalyticsSource } from '@atlassian/jira-analytics-web-react/src/components/decorators.tsx';
import { INLINE_DIALOG } from '@atlassian/jira-product-analytics-bridge';
import { connect } from '@atlassian/jira-react-redux/src/index.tsx';
import { ANALYTIC_CONTEXTS } from '@atlassian/jira-servicedesk-common/src/utils/analytics/index.tsx';
import { getActivationId, getProjectId } from '../../../state/selectors/base/index.tsx';
import type { State } from '../../../state/types.tsx';
import SearchKnowledgeInline from './view.tsx';

export default flow(
	AnalyticsSource('knowledgeInlineSearch', INLINE_DIALOG),
	AnalyticsData({
		attributes: {
			context: ANALYTIC_CONTEXTS.KNOWLEDGE,
		},
	}),
	// @ts-expect-error - TS2589 - Type instantiation is excessively deep and possibly infinite.
	connect(
		(state: State) => ({
			projectId: getProjectId(state),
			activationId: getActivationId(state),
		}),
		{},
	),
)(SearchKnowledgeInline);
